export interface MimeExtensionModel {
    extension: string;
    mime_type: string;
}

export class MimeExtensionClass {
    mimeExtension: MimeExtensionModel[] = [
        { extension: '.doc', mime_type: 'application/msword' },
        { extension: '.docx', mime_type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
        { extension: '.dotx', mime_type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template' },
        { extension: '.docm', mime_type: 'application/vnd.ms-word.document.macroEnabled.12' },
        { extension: '.dotm', mime_type: 'application/vnd.ms-word.template.macroEnabled.12' },

        { extension: '.xls', mime_type: 'application/vnd.ms-excel' },
        { extension: '.xlsx', mime_type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
        { extension: '.xltx', mime_type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template' },
        { extension: '.xlam', mime_type: 'application/vnd.ms-excel.addin.macroEnabled.12' },
        { extension: '.xlsm', mime_type: 'application/vnd.ms-excel.sheet.macroEnabled.12' },
        { extension: '.xlsb', mime_type: 'application/vnd.ms-excel.sheet.binary.macroEnabled.12' },
        { extension: '.xltm', mime_type: 'application/vnd.ms-excel.template.macroEnabled.12' },

        { extension: '.ppt', mime_type: 'application/vnd.ms-powerpoint' },
        { extension: '.pptx', mime_type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' },
        { extension: '.potx', mime_type: 'application/vnd.openxmlformats-officedocument.presentationml.template' },
        { extension: '.ppsx', mime_type: 'application/vnd.openxmlformats-officedocument.presentationml.slideshow' },
        { extension: '.ppam', mime_type: 'application/vnd.ms-powerpoint.addin.macroEnabled.12' },
        { extension: '.pptm', mime_type: 'application/vnd.ms-powerpoint.presentation.macroEnabled.12' },
        { extension: '.potm', mime_type: 'application/vnd.ms-powerpoint.template.macroEnabled.12' },
        { extension: '.ppsm', mime_type: 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12' },

        { extension: '.mdb', mime_type: 'application/vnd.ms-access' },
        { extension: '.dwg', mime_type: 'image/vnd.dwg' },
        { extension: '.xcf', mime_type: 'image/x-xcf' },
        { extension: '.jpg', mime_type: 'image/jpeg' },
        { extension: '.jpx', mime_type: 'image/jpx' },
        { extension: '.png', mime_type: 'image/png' },
        { extension: '.apng', mime_type: 'image/apng' },
        { extension: '.gif', mime_type: 'image/gif' },
        { extension: '.webp', mime_type: 'image/webp' },
        { extension: '.cr2', mime_type: 'image/x-canon-cr2' },
        { extension: '.tif', mime_type: 'image/tiff' },
        { extension: '.bmp', mime_type: 'image/bmp' },
        { extension: '.jxr', mime_type: 'image/vnd.ms-photo' },
        { extension: '.psd', mime_type: 'image/vnd.adobe.photoshop' },
        { extension: '.ico', mime_type: 'image/x-icon' },
        { extension: '.heic', mime_type: 'image/heic' },
        { extension: '.avif', mime_type: 'image/avif' },
        { extension: '.3gp', mime_type: 'video/3gpp' },
        { extension: '.mp4', mime_type: 'video/mp4' },
        { extension: '.m4v', mime_type: 'video/x-m4v' },
        { extension: '.mkv', mime_type: 'video/x-matroska' },
        { extension: '.webm', mime_type: 'video/webm' },
        { extension: '.mov', mime_type: 'video/quicktime' },
        { extension: '.avi', mime_type: 'video/x-msvideo' },
        { extension: '.wmv', mime_type: 'video/x-ms-wmv' },
        { extension: '.mpg', mime_type: 'video/mpeg' },
        { extension: '.flv', mime_type: 'video/x-flv' },
        { extension: '.aac', mime_type: 'audio/aac' },
        { extension: '.mid', mime_type: 'audio/midi' },
        { extension: '.mp3', mime_type: 'audio/mpeg' },
        { extension: '.m4a', mime_type: 'audio/mp4' },
        { extension: '.ogg', mime_type: 'audio/ogg' },
        { extension: '.flac', mime_type: 'audio/x-flac' },
        { extension: '.wav', mime_type: 'audio/x-wav' },
        { extension: '.amr', mime_type: 'audio/amr' },
        { extension: '.aiff', mime_type: 'audio/x-aiff' },
        { extension: '.br', mime_type: 'application/x-brotli' },
        { extension: '.rpm', mime_type: 'application/x-rpm' },
        { extension: '.dcm', mime_type: 'application/dicom' },
        { extension: '.epub', mime_type: 'application/epub+zip' },
        { extension: '.zip', mime_type: 'application/zip' },
        { extension: '.tar', mime_type: 'application/x-tar' },
        { extension: '.rar', mime_type: 'application/x-rar-compressed' },
        { extension: '.gz', mime_type: 'application/gzip' },
        { extension: '.bz2', mime_type: 'application/x-bzip2' },
        { extension: '.7z', mime_type: 'application/x-7z-compressed' },
        { extension: '.xz', mime_type: 'application/x-xz' },
        { extension: '.pdf', mime_type: 'application/pdf' },
        { extension: '.exe', mime_type: 'application/x-msdownload' },
        { extension: '.swf', mime_type: 'application/x-shockwave-flash' },
        { extension: '.rtf', mime_type: 'application/rtf' },
        { extension: '.eot', mime_type: 'application/octet-stream' },
        { extension: '.ps', mime_type: 'application/postscript' },
        { extension: '.sqlite', mime_type: 'application/x-sqlite3' },
        { extension: '.nes', mime_type: 'application/x-nintendo-nes-rom' },
        { extension: '.crx', mime_type: 'application/x-google-chrome-extension' },
        { extension: '.cab', mime_type: 'application/vnd.ms-cab-compressed' },
        { extension: '.deb', mime_type: 'application/x-deb' },
        { extension: '.ar', mime_type: 'application/x-unix-archive' },
        { extension: '.Z', mime_type: 'application/x-compress' },
        { extension: '.lzo', mime_type: 'application/x-lzop' },
        { extension: '.lz', mime_type: 'application/x-lzip' },
        { extension: '.lz4', mime_type: 'application/x-lz4' },
        { extension: '.zstd', mime_type: 'application/zstd' },
        { extension: '.odt', mime_type: 'application/vnd.oasis.opendocument.text' },
        { extension: '.ods', mime_type: 'application/vnd.oasis.opendocument.spreadsheet' },
        { extension: '.odp', mime_type: 'application/vnd.oasis.opendocument.presentation' },
        { extension: '.woff', mime_type: 'application/font-woff' },
        { extension: '.woff2', mime_type: 'application/font-woff' },
        { extension: '.ttf', mime_type: 'application/font-sfnt' },
        { extension: '.otf', mime_type: 'application/font-sfnt' },
        { extension: '.wasm', mime_type: 'application/wasm' },
    ]
}
